import { NavItem } from '@billy/design-system'
import { TFunction } from 'i18next'

import { CountryIsoCode } from '../../../../types/countryIsoCode'
import { locales } from '../../../../utils/i18n'
import { CountryFlag } from '../../../CountryFlag'
import { LocaleFormat } from '../types/LocaleFormat'

/* eslint-disable @typescript-eslint/naming-convention */
const localeToLanguageTKey: Partial<Record<LocaleFormat, string>> = {
  da_DK: 'settings.user.language.da_DK',
  en_US: 'settings.user.language.en_US',
  en_GB: 'settings.user.language.en_GB',
  fr_FR: 'settings.user.language.fr_FR',
  nl_NL: 'settings.user.language.nl_NL',
  de_DE: 'settings.user.language.de_DE',
}

const localeToCountryIsoCode: Record<LocaleFormat, CountryIsoCode> = {
  da_DK: 'dk',
  en_US: 'us',
  en_GB: 'gb',
  fr_FR: 'fr',
  nl_NL: 'nl',
  de_DE: 'de',
}

export const getLanguageItems = (t: TFunction, languages?: LocaleFormat[]): NavItem<LocaleFormat>[] => {
  const defaultLocales = Object.values(locales).filter((locale) => localeToLanguageTKey[locale]) as LocaleFormat[]
  const activeLocales = languages ?? defaultLocales

  return activeLocales.map((locale) => {
    const countryCode = localeToCountryIsoCode[locale]
    const tKey = t(localeToLanguageTKey[locale] ?? locale)

    return {
      id: locale,
      children: tKey,
      title: countryCode,
      leftDecoration: <CountryFlag countryCode={countryCode} />,
      value: locale,
    }
  })
}
